import { BaseDataDto } from './base-data.dto';
export class BaseStringIdDataDto extends BaseDataDto {
    constructor(initializer) {
        super(initializer);
        this.id = initializer.id;
    }
}
